enum NotificationDocumentTypeId {
	Pdf = 1,
	Png = 2
}

export default NotificationDocumentTypeId;
